<template>
  <div>
    <slot :data="cData" :loading="loading" :empty="empty"></slot>
    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <!-- <div slot="spinner">Loading...</div> -->
      <error-message slot="no-more" :text="text" />
      <error-message slot="no-results" :text="text2" />
    </infinite-loading>
  </div>
</template>

<script type="text/javascript">
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "yun-scroll",
  data() {
    return {
      height: 0,
      page: 1,
      data: [],
      loading: 0,
      infiniteId: 1,
      btnFlag: false,
    };
  },
  //返回时要修改
  props: {
    limit: {
      type: Number,
      default: 10,
    },
    url: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    text: {
      type: String,
      default: "没有更多数据了",
    },
    text2: {
      type: String,
      default: "暂无数据",
    },
    computeData: Function,
  },
  computed: {
    sendData() {
      return {
        ...this.params,
        page: this.page,
        limit: this.limit,
      };
    },
    trigger() {
      return this.url + "?" + this.$QueryString.stringify(this.params);
    },
    cData() {
      return (
        (typeof this.computeData === "function"
          ? this.computeData(this.data)
          : this.data) || []
      );
    },
    empty() {
      return !this.cData.length;
    },
  },

  created() {},
  mounted() {},
  methods: {
    infiniteHandler($state) {
      this.data = [
        {
          create_time: "2023-07-07 10:34:45",
          deadline_cycle: "0",
          deadline_num: "0",
          goods_content: "3/天",
          goods_detail: "国庆放心玩 假期交给我",
          goods_name: "[云手机VIP]-1天",
          id: "2",
          is_limit: "0",
          itemId: "24",
          limit: "0",
          price: "3.00",
          stock: "9999",
        },
        {
          create_time: "2023-07-07 10:34:45",
          deadline_cycle: "0",
          deadline_num: "0",
          goods_content: "2.14/天",
          goods_detail: "国庆放心玩 假期交给我",
          goods_name: "[云手机VIP]-7天",
          id: "166",
          is_limit: "0",
          itemId: "300",
          limit: "0",
          price: "15.00",
          stock: "9999",
        },
        {
          create_time: "2023-07-05 13:24:37",
          deadline_cycle: "0",
          deadline_num: "0",
          goods_content: "",
          goods_detail: "国庆放心玩 假期交给我",
          goods_name: "[云手机VIP]-30天",
          id: "142",
          is_limit: "0",
          itemId: "266",
          limit: "0",
          price: "58.00",
          stock: "9999",
        },
        {
          create_time: "2023-07-05 13:24:37",
          deadline_cycle: "0",
          deadline_num: "0",
          goods_content: "",
          goods_detail: "",
          goods_name: "[云手机VIP]-90天",
          id: "143",
          is_limit: "0",
          itemId: "266",
          limit: "0",
          price: "105.00",
          stock: "9999",
        },
      ];
      $state.complete();
      return;
      if (this.url != "") {
        this.loading++;
        this.$Ajax(this.url, this.sendData)
          .then((rs) => {
            this.page++;
            this.$emit("on-fetch", {
              data: rs.data.list,
            });
            if (
              rs.code == 200 &&
              rs.data.list instanceof Array &&
              rs.data.list.length > 0
            ) {
              this.data.push(...rs.data.list);
              $state.loaded();
            }
            if (
              !rs.data.page_info.totalPage ||
              rs.data.page_info.page >= rs.data.page_info.totalPage
            ) {
              $state.complete();
            }
          })
          .finally(() => {
            //this.loading--;
          });
      }
    },
    refresh() {
      this.page = 1;
      this.data = [];
      this.infiniteId++;
    },
  },
  watch: {
    trigger: "refresh",
  },
  components: {
    InfiniteLoading,
  },
};
</script>

<style lang="less" scoped>
.empty-bg {
  .box {
    margin: 3.25rem 4.1rem 0;
    opacity: 0.83;
    img {
      width: 100%;
      height: 100%;
    }
    p {
      text-align: center;
      opacity: 1;
      color: #000000;
    }
  }
}
</style>
